import { render, staticRenderFns } from "./PlantsWithoutStatInsps.vue?vue&type=template&id=aa812494"
import script from "./PlantsWithoutStatInsps.vue?vue&type=script&lang=js"
export * from "./PlantsWithoutStatInsps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports